import { DecisionMakersMainWrapper } from '../decisionMakers/DecisionMakersMainWrapper';
import { LegislativeBodiesContainer } from '../decisionMakersLegislativeBodies/LegislativeBodiesContainer';

import { useDecisionMakerSection } from './hooks/useDecisionMakerSection';

export const DecisionMakerSection: React.FC = () => {
	const {
		data: { showLegislativeBodies },
	} = useDecisionMakerSection();

	return <div>{showLegislativeBodies ? <LegislativeBodiesContainer /> : <DecisionMakersMainWrapper />}</div>;
};
